import { AcquisitionCell } from 'pages/CapTable/fund-ownership/models/fund-ownership.models';

/* eslint-disable no-param-reassign */
const calculateTotalByAcquisitionRef = (aliasCriteria: string, data: Array<AcquisitionCell>) =>
  data.reduce((acum: Record<string, number>, { value, acquisition_ref: acquisitionRef, alias }) => {
    if (acum[acquisitionRef] === undefined) {
      acum[acquisitionRef] = 0;
    }
    if (alias === aliasCriteria) {
      acum[acquisitionRef] += Number(value);
    }
    return acum;
  }, {});

export default calculateTotalByAcquisitionRef;
